import React from "react";
import x from "Images/profile/small_x.svg";
import styles from "./styles.module.scss";

function TopRightX(props) {
  return (
    <>
      <div
        onClick={props.onClick}
        className={styles["top-right-x-container"]}
        tabIndex={0}
        onKeyUp={props.onClick}
        role="button"
      >
        <img src={x} className={styles["top-right-x"]} alt="top-right-x" />
      </div>
    </>
  );
}

export default TopRightX;
